function GenesUniProt() {
  return (
    <div className="genes-uniprot">
      <li className="bullet-item">
        The{' '}
        <a className="tt" target="_blank" rel="noreferrer" href="http://www.uniprot.org/uniprot/">
          Uniprot{' '}
        </a>{' '}
        accession
      </li>
    </div>
  );
}

export default GenesUniProt;
